import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';
import { OverviewCardFinger } from 'Douleutaras/components/OverviewCard/OverviewCard';
import { StatsRequestProps } from 'Douleutaras/redux/data/stats/types';

const STATS_OVERVIEW_API = 'api/public/v3/stats/overview';

export interface StatsOverview {
  jobs_assigned: number;
  jobs_assigned_trend: OverviewCardFinger;
  quote_rate: number;
  quote_rate_trend: OverviewCardFinger;
  fulfillment_rate: number;
  fulfillment_rate_trend: OverviewCardFinger;
  revenue_assigned: number;
  revenue_assigned_trend: OverviewCardFinger;
  revenue_assigned_job: number;
  revenue_assigned_job_trend: OverviewCardFinger;
  response_time: number;
  response_time_trend: OverviewCardFinger;
  rank: number;
  tier: number;
}

const overviewCacheMap: Map<string, StatsOverview> = new Map();

export const getStatsOverview = createAsyncThunk<StatsOverview, StatsRequestProps>(
  'stats/overview/get',
  async ({ catId, subCatId, from, to }, api) => {
    const request = `${STATS_OVERVIEW_API}/${catId}/${subCatId}/${from}/${to}/`;
    if (!overviewCacheMap.has(request)) {
      const response = await makeRequest(
        request,
        {
          method: 'GET'
        }
      )(api);
      overviewCacheMap.set(request, response.data.data);

      return response.data.data;
    } else {
      return overviewCacheMap.get(request);
    }
  }
);
